export interface LegalSection {
  heading: string;
  content: string;
  list?: string[];
  footer?: string;
}

export interface LegalPage {
  title: string;
  lastUpdated: string;
  intro: string;
  sections: LegalSection[];
}

/**
 * Builds markdown for the legal modal body. The document title is omitted because
 * the modal header already shows it.
 */
export function legalPageToMarkdown(page: LegalPage): string {
  const parts: string[] = [
    `_Last updated: ${page.lastUpdated}_`,
    '',
    page.intro.trim(),
  ];

  for (const section of page.sections) {
    parts.push('', `## ${section.heading}`);
    if (section.content?.trim()) {
      parts.push('', section.content.trim());
    }
    if (section.list?.length) {
      parts.push('');
      for (const item of section.list) {
        parts.push(`- ${item}`);
      }
    }
    if (section.footer?.trim()) {
      parts.push('', section.footer.trim());
    }
  }

  return parts.join('\n');
}
